<template>
  <div class="ai-welcome">
    <div class="ai-welcome-hero">
      <span class="ai-welcome-logo"><img src="@/assets/images/iaLOGO.png" alt="" /></span>
      <h3>Bonjour, comment puis-je vous aider ?</h3>
      <p>
        Consultez vos données, analysez un fichier ou préparez une action :
        rien n’est créé ni modifié sans votre confirmation.
      </p>
    </div>

    <div v-for="group in groups" :key="group.title" class="ai-welcome-group">
      <div class="ai-welcome-group-title">
        <i :class="group.icon"></i>{{ group.title }}
      </div>
      <div class="ai-welcome-chips">
        <button
          v-for="question in group.questions"
          :key="question"
          type="button"
          class="ai-chip"
          @click="$emit('pick', question)"
        >
          {{ question }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export const SUGGESTION_GROUPS = [
  {
    title: 'Ventes',
    icon: 'fas fa-file-invoice-dollar',
    questions: [
      'Donner les factures de vente',
      'Quels sont les factures impayés ?',
      'Quelles sont les factures partiellement payées ?',
      'CA Total',
    ],
  },
  {
    title: 'Achats & dépenses',
    icon: 'fas fa-shopping-cart',
    questions: ['Donner les factures d’achat', 'Afficher les dépenses', 'Afficher les fournisseurs'],
  },
  {
    title: 'Clients, équipe & stock',
    icon: 'fas fa-users',
    questions: [
      'Afficher les clients',
      'Afficher les employés',
      'Afficher les articles du catalogue',
      'Afficher les alertes',
    ],
  },
];

export default {
  name: 'AssistantWelcome',
  emits: ['pick'],
  data() {
    return { groups: SUGGESTION_GROUPS };
  },
};
</script>

<style scoped>
.ai-welcome {
  padding: 8px 4px 4px;
}

.ai-welcome-hero {
  text-align: center;
  margin-bottom: 20px;
}

.ai-welcome-logo {
  width: 52px;
  height: 52px;
  margin: 0 auto 12px;
  border-radius: 16px;
  border: 1px solid var(--ai-line);
  background: var(--ai-surface);
  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.12);
  display: grid;
  place-items: center;
}

.ai-welcome-logo img {
  width: 34px;
  height: 34px;
  object-fit: contain;
}

.ai-welcome-hero h3 {
  margin: 0 0 6px;
  font-size: 17px;
  font-weight: 700;
  color: var(--ai-ink);
}

.ai-welcome-hero p {
  max-width: 320px;
  margin: 0 auto;
  font-size: 13px;
  line-height: 1.5;
  color: var(--ai-muted);
}

.ai-welcome-group {
  margin-top: 14px;
}

.ai-welcome-group-title {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--ai-faint);
}

.ai-welcome-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.ai-chip {
  padding: 7px 11px;
  border: 1px solid var(--ai-line);
  border-radius: 999px;
  background: var(--ai-surface);
  color: #334155;
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: border-color 140ms ease, color 140ms ease, background-color 140ms ease, transform 140ms var(--ai-ease);
}

.ai-chip:hover {
  border-color: var(--ai-primary-line);
  background: var(--ai-primary-soft);
  color: var(--ai-primary);
}

.ai-chip:active {
  transform: scale(0.97);
}
</style>
